/**
 * Created by LJW on 2017/6/21.
 *
 * usage:
 * methods: {
 *    fetchData: async function () {
 *     let params = {}
 *     const res = await this.http.get(api.apiStart, params)
 *     if (res.data.success) {
 *       alert('请求成功')
 *     }
 *   }
 * }
 */

import axios from 'axios'
import { baseUrl } from '../config/env'
// import encrypt from '@/api/encrypt'

const wu = require('@/lib/wu-ui/wu-ui.js')
require('@/lib/wu-ui/wu-ui.css')
require('@/lib/wu-ui/iconfont.css')

// Loading,
// let loading

axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error.response)
})

// axios.defaults.withCredentials = true

function showLoading (that) {
  if (that) {
    that.$vux.loading.show({
      text: '加载中'
    })
  }
}

function hideLoading (that) {
  // window.removeLoading(name)
  if (that) {
    that.$vux.loading.hide()
  }
}

function checkStatus (response, that) {
  // requestDataBase += `
  // <p>endTime: <span style="color: red;">${new Date().getTime()}</span></p>
  // <p>北京时间(结束): <span style="color: red;">${new Date().format('yyyy-MM-dd HH:mm:ss')}</span></p>
  // `
  // sessionStorage.setItem('requestDataBase', requestDataBase)
  // 如果http状态码正常，则直接返回数据
  // if (checkCode(response, name)) {
  //   return response.data.content
  // }
  // openid
  if (response && response.returnCode === '10002') {
    let url = window.location.href
    const index = url.indexOf('#') + 1
    url = url.substring(0, index)
    url += `/maintain?data=${response.returnMsg}`
    window.location.href = url
    return
  }
  if (response.returnCode === '10013') {
    let url = window.location.href
    const index = url.indexOf('#') + 1
    url = url.substring(0, index)
    url += '/notlogin'
    window.location.href = url
    return
  }
  if (response.content === null || response.content === undefined) { response.content = {} }
  response.content.returnCode = response.returnCode
  response.content.returnMsg = response.returnMsg
  if (response.returnCode === '10005') {
    wu.default.showMessage(response.returnMsg)
    return response.content
  }
  if (response.returnCode === '00000') {
    return response.content
  }
  wu.default.showMessage(response.returnMsg)
  // 显示文字
  throw new Error('errorMsg: ' + response.returnMsg)
}

export default {
  post (url, data, that, flag = true) {
    // let requestDataBase = window.sessionStorage.getItem('requestDataBase') || ''
    // requestDataBase += `
    // <br/>
    // <p>------ 一点都不华丽的分割线 ------</p>
    // <p>url: <span style="color: red;">${url}</span></p>
    // <p>北京时间(开始): <span style="color: red;">${new Date().format('yyyy-MM-dd HH:mm:ss')}</span></p>
    // <p>startTime: <span style="color: red;">${new Date().getTime()}</span></p>
    // `
    showLoading(that)
    let openId = window.localStorage.getItem('openId')
    // openId = 'oLS8Sw7Q6uohBoLn4Nx6-K27C81s'
    return axios({
      method: 'post',
      baseURL: baseUrl,
      headers: {'cpm-client-type': 'wechat', 'cpm-user-identity': openId},
      url,
      data: data, // encrypt.getObject(data),
      timeout: 30000
    }).then(
      (response) => {
        flag = false
        hideLoading(that)
        return checkStatus(response.data, that)
      }
    ).catch(() => {
      hideLoading(that)
      if (flag) wu.default.showMessage('网络错误')
    })
  },
  get (url, params, that, flag = true) {
    showLoading(that)
    let openId = window.localStorage.getItem('openId')
    return axios({
      method: 'get',
      baseURL: baseUrl,
      headers: {
        'cpm-client-type': 'wechat',
        'cpm-user-identity': openId,
        'X-Requested-With': 'XMLHttpRequest'
      },
      url,
      params, // get 请求时带的参数
      timeout: 60000
    }).then(
      (response) => {
        flag = false
        hideLoading(that)
        const result = checkStatus(response.data, that)
        flag = false
        return result
      }
    ).catch(() => {
      hideLoading(that)
      if (flag) wu.default.showMessage('网络错误')
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/request.js